const RefundArrowIcon = ({ size = 12, color = "black", ...props }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M11.25 6.93749C11.25 7.93205 10.855 8.88588 10.1517 9.58914C9.44843 10.2924 8.4946 10.6875 7.50004 10.6875H1.12504V9.93749H7.50004C8.29569 9.93749 9.05875 9.62142 9.62136 9.05881C10.184 8.4962 10.5 7.73314 10.5 6.93749C10.5 6.14184 10.184 5.37878 9.62136 4.81617C9.05875 4.25356 8.29569 3.93749 7.50004 3.93749H2.16004L3.61504 5.14874L3.13504 5.72624L0.540039 3.56249L3.13504 1.39874L3.61504 1.97624L2.16004 3.18749H7.50004C8.4946 3.18749 9.44843 3.58258 10.1517 4.28584C10.855 4.9891 11.25 5.94293 11.25 6.93749Z"
			fill={color}
		/>
	</svg>
);

export default RefundArrowIcon;
